import axios from 'axios';
import { getAuthHeaders, handleAuthError } from './authUtils';

const createQueryString = (params = {}) => {
  const {
    page,
    limit,
    sortBy,
    sortDirection,
    search,
    ...otherParams
  } = params;

  const queryParams = new URLSearchParams();

  if (page !== undefined) {
    queryParams.append('page', page);
  }

  if (limit !== undefined) {
    queryParams.append('limit', limit);
  }

  if (sortBy) {
    queryParams.append('sort_by', sortBy);
  }

  if (sortDirection) {
    queryParams.append('sort_direction', sortDirection);
  }

  if (search) {
    queryParams.append('search', search);
  }

  // Add any additional parameters
  Object.entries(otherParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      queryParams.append(key, value);
    }
  });

  return queryParams.toString();
};

// Base API request function with auth error handling
const apiRequest = async (method, url, data = null, params = null) => {
  try {
    const config = {
      method,
      url,
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      withCredentials: true,
      ...(data && { data }),
      ...(params && { params }),
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    handleAuthError(error);
    throw error;
  }
};

// Convenience methods for different HTTP verbs
export const get = (url, params) => apiRequest('GET', url, null, params);
export const post = (url, data) => apiRequest('POST', url, data);
export const put = (url, data) => apiRequest('PUT', url, data);
export const del = (url) => apiRequest('DELETE', url);

export { createQueryString };